var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.3,
    height: 32.301,
    viewBox: "0 0 32.3 32.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#016fd0;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.5,1002.35H87.714v17.437l-1.595,2.5,1.595,2.224v10.142H55.5v-16.437l1-1.15-1-1.1Z",
    transform: "translate(-55.5 -1002.35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M249.14,1546.276v-5.445H254.9l.618.806.639-.806h20.925v5.069a2.416,2.416,0,0,1-1.18.376H264.321l-.7-.859v.859h-2.285v-1.465a1.918,1.918,0,0,1-.987.2h-.778v1.261h-3.46l-.618-.824-.627.824Z",
    transform: "translate(-244.874 -1523.634)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.5,1338.654l1.2-3.031h2.077l.682,1.7v-1.7h2.582l.406,1.227.393-1.227H74.43v.617a2.4,2.4,0,0,1,1.611-.617l3.761.014.67,1.676v-1.69h2.161l.595.962v-.962h2.18v5.445h-2.18l-.57-.966v.966H79.482l-.319-.858H78.31l-.314.858H75.843a2.059,2.059,0,0,1-1.412-.6v.6H71.184l-.644-.858v.858H58.47l-.319-.858H57.3l-.317.858H55.5Z",
    transform: "translate(-55.5 -1324.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.446,1354.93l-1.753,4.077h1.142l.324-.816h1.881l.322.816h1.167l-1.752-4.077H57.446Zm.649.949.573,1.427H57.52Z",
    transform: "translate(-55.686 -1343.625)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M198.223,1358.983v-4.077l1.622.006.944,2.629.921-2.635h1.609v4.077H202.3v-3l-1.08,3h-.894l-1.083-3v3Z",
    transform: "translate(-193.261 -1343.602)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.861,1358.983v-4.077h3.326v.912h-2.3v.7h2.242v.858h-2.242v.724h2.3v.885Z",
    transform: "translate(-354.949 -1343.602)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M477.5,1354.93v4.077h1.019v-1.448h.429l1.222,1.448h1.246l-1.341-1.5a1.241,1.241,0,0,0,1.118-1.252,1.319,1.319,0,0,0-1.425-1.323Zm1.019.912h1.165a.468.468,0,0,1,.483.429.461.461,0,0,1-.468.429h-1.18Z",
    transform: "translate(-463.998 -1343.625)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M596.727,1358.983h-1.041v-4.077h1.041Z",
    transform: "translate(-578.28 -1343.602)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M641.864,1358.983h-.225a1.8,1.8,0,0,1-1.747-2.022,1.868,1.868,0,0,1,2.025-2.055h1.126v.966h-1.168a.98.98,0,0,0-.951,1.1,1,1,0,0,0,1.1,1.121h.268Z",
    transform: "translate(-621.16 -1343.602)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M711.705,1354.93l-1.753,4.077h1.142l.324-.816H713.3l.322.816h1.167l-1.752-4.077Zm.649.949.573,1.427h-1.148Z",
    transform: "translate(-689.073 -1343.625)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M852.433,1358.983v-4.077h1.3l1.655,2.562v-2.562H856.4v4.077h-1.254l-1.7-2.628v2.628Z",
    transform: "translate(-827.193 -1343.602)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M269.2,1564.2v-4.077h3.326v.912h-2.3v.7h2.242v.858h-2.242v.724h2.3v.885Z",
    transform: "translate(-262.351 -1542.242)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M737.947,1564.2v-4.077h3.326v.912h-2.3v.7h2.231v.858h-2.231v.724h2.3v.885Z",
    transform: "translate(-716.082 -1542.242)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M367.5,1564.2l1.619-2.013-1.658-2.064h1.284l.987,1.276.991-1.276h1.234l-1.636,2.039,1.622,2.038h-1.284l-.959-1.256-.935,1.256Z",
    transform: "translate(-357.503 -1542.242)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M499.869,1560.14v4.077h1.046v-1.287h1.073a1.41,1.41,0,0,0,1.6-1.418,1.342,1.342,0,0,0-1.463-1.371Zm1.046.922h1.13a.46.46,0,0,1,.5.469.47.47,0,0,1-.506.469h-1.126Z",
    transform: "translate(-485.647 -1542.256)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M619.448,1560.12v4.077h1.019v-1.448h.429l1.222,1.448h1.246l-1.341-1.5a1.242,1.242,0,0,0,1.118-1.253,1.319,1.319,0,0,0-1.425-1.323Zm1.019.912h1.165a.468.468,0,0,1,.483.429.46.46,0,0,1-.468.429h-1.18Z",
    transform: "translate(-601.409 -1542.236)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M843.594,1564.2v-.885h2.04c.3,0,.433-.163.433-.342s-.13-.345-.433-.345h-.922a1.14,1.14,0,0,1-1.247-1.221c0-.654.409-1.284,1.6-1.284h1.985l-.429.917H844.9c-.328,0-.429.172-.429.337a.355.355,0,0,0,.375.355h.966a1.118,1.118,0,0,1,1.281,1.17,1.223,1.223,0,0,1-1.329,1.3Z",
    transform: "translate(-818.536 -1542.242)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M951.191,1564.2v-.885h2.04c.3,0,.433-.163.433-.342s-.13-.345-.433-.345h-.922a1.14,1.14,0,0,1-1.247-1.221c0-.654.409-1.284,1.6-1.284h1.985l-.429.917H952.5c-.328,0-.429.172-.429.337a.355.355,0,0,0,.375.355h.965a1.118,1.118,0,0,1,1.281,1.17,1.222,1.222,0,0,1-1.329,1.3Z",
    transform: "translate(-922.392 -1542.242)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.be1775a2f642f3693ea7881cab0fd36d.svg";
export { ForwardRef as ReactComponent };